import { render, staticRenderFns } from "./AddIssueTask.vue?vue&type=template&id=e6f6fd62"
import script from "./AddIssueTask.vue?vue&type=script&lang=js"
export * from "./AddIssueTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports